class MultimediaBlock extends HTMLElement {
    constructor() {
        super();
        this.selectors = {
            grid: ".js-grid",
            article: ".js-article",
            loadMore: ".js-load-more",
            playBtn: ".js-play"
        };
        this.grid = this.querySelector(this.selectors.grid);
        this.loadMore = this.querySelector(this.selectors.loadMore);
        this.url = this.getAttribute('data-tag')
        this.dataSection = this.getAttribute('data-section')
        this.init();
    }

    checkLoadMore(html) {
        const newLoadMore = html.querySelector(this.selectors.loadMore);
        if (newLoadMore != null) {
            this.loadMore.classList.add('is-visible');
            this.loadMore.setAttribute('data-next', newLoadMore.getAttribute('data-next'));
        } else {
            this.loadMore.classList.remove('is-visible');
        }
    }

    initLoadMore() {
        this.loadMore.addEventListener('click', () => {
            this.getHtml(this.loadMore.getAttribute('data-next'));
        });
    }

    getHtml(url) {
        fetch(url).then((response) => {
            return response.json();
        })
            .then((state) => {
                const html = new DOMParser().parseFromString(state[this.dataSection], 'text/html');
                html.querySelectorAll(this.selectors.article).forEach((el) => {
                    this.grid.append(el);
                });
                setTimeout(() => {
                    this.querySelectorAll(this.selectors.article).forEach((el, index) => {
                        el.classList.remove('is-hidden');
                    });
                }, 10)

                this.checkLoadMore(html);
                this.initPlay();
            })
            .catch((error) => {
                this.style.display = "none";
            });
    }

    initPlay() {
        this.playBtn = this.querySelectorAll(this.selectors.playBtn);
        this.playBtn.forEach(el => {
            el.addEventListener('click', () => {
                const parent = el.closest('.js-article');
                if (parent != null) {
                    parent.classList.add('is-playing');
                    parent.querySelector('video')?.play();
                }
            });
        })
    }

    init() {
        this.getHtml(this.url);
        this.initLoadMore();
        this.initPlay();

    }
}

export default MultimediaBlock;
